import React from "react";
import { StyledEmptyState, StyledEmptyStateText } from "./StyledEmptyState";
import { useReactAppState } from "../../containers/utils";

function EmptyState({ emptyStateTranslation }) {
  const { t } = useReactAppState();

  return (
    <StyledEmptyState>
      <svg viewBox="0 0 159 87">
        <g fill="none" fillRule="evenodd">
          <path
            stroke="#000"
            strokeWidth="5"
            d="M156.2 20a14.6 14.6 0 11-29.2 0 14.6 14.6 0 0129.2 0zm-34 17.5L74.9 85m47.5-27.5L94.8 85"
          />
          <path
            fill="#000"
            d="M6 0L0 6v50.8h.2L5 52V5h83.3v51.8h.1l4.9-4.9V0z"
          />
        </g>
      </svg>
      <StyledEmptyStateText>{t(emptyStateTranslation)}</StyledEmptyStateText>
    </StyledEmptyState>
  );
}

export default EmptyState;
